import { render } from "./mat-multi-select.vue?vue&type=template&id=5b6999a8&scoped=true&lang=true"
import script from "./mat-multi-select.vue?vue&type=script&lang=js"
export * from "./mat-multi-select.vue?vue&type=script&lang=js"

import "./mat-multi-select.vue?vue&type=style&index=0&id=5b6999a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6999a8"]])

export default __exports__